import {api} from "./service.js";   
const install={
	// 人员列表
	usrList(data){
	    return api.get("/admin/system.admin/selectFields",data)
	},
	// 密码修改
	modifyPwd(data){
	    return api.post("/admin/system.admin/password",data)
	},
	// 角色删除
	delRole(data){
	    return api.post("/admin/system.auth/delete",data)
	},
	// 角色编辑
	editRole(data){
	    return api.post("/admin/system.auth/edit",data)
	},
	// 角色启用禁用
	authState(data){
	    return api.post("/admin/system.auth/modify",data)
	},
	// 角色添加
	addRole(data){
	    return api.post("/admin/system.auth/add",data)
	},
	// 账号密码重置
	resetPwd(data){
	    return api.post("/admin/system.admin/resetpassword",data)
	},
	// 账号启用禁用
	modifyState(data){
	    return api.post("/admin/system.admin/modify",data)
	},
	// 账号编辑
	editAccount(data){
	    return api.post("/admin/system.admin/edit",data)
	},
	// 账号删除
	delAccount(data){
	    return api.post("/admin/system.admin/delete",data)
	},
	// 账号添加
	addAccount(data){
	    return api.post("/admin/system.admin/add",data)
	},
	// 角色列表|角色选择列表
	roleList(data){
	    return api.get("/admin/system.auth/index",data)
	},
	// 账号列表
    userList(data){
        return api.get("/admin/system.admin/index",data)
    },
	// 退出登录
	exitLogin(data){
	    return api.post("/admin/login/out.html",data);
	},
	// 用户登录
    login(data){
        return api.post("/admin/login/index.html",data);
    }
}
export default install;